import RedirectToLogin from "../utils/RedirectToLogin";
import routesConstants from "./routesConstants";
import {
  AuthenticationPage,
  KPIPage,
  PulseOverviewPage,
  PulseProjectPage,
  PulsePortalPage,
  PulseReportsPage,
  PulseAdminPage,
} from "./routesImport";

const routesConfig = {
  private: [
    {
      path: routesConstants.PULSE,
      Component: PulseOverviewPage,
      permission: false,
    },
    {
      path: routesConstants.PULSE_PROJECT,
      Component: PulseProjectPage,
      permission: false,
    },
    {
      path: routesConstants.PULSE_PORTAL,
      Component: PulsePortalPage,
      permission: false,
    },
    {
      path: routesConstants.PULSE_REPORTS,
      Component: PulseReportsPage,
      permission: false,
    },
    {
      path: routesConstants.PULSE_ADMIN,
      Component: PulseAdminPage,
      permission: false,
    },
    {
      path: routesConstants.KPI,
      Component: KPIPage,
      permission: false,
    },
  ],
  public: [
    {
      path: "/",
      Component: RedirectToLogin,
    },
    {
      path: routesConstants.AUTHENTICATION_PAGE,
      Component: AuthenticationPage,
    },
  ],
};

export default routesConfig;
